import validator from 'validator';

export const EMAIL_MAX_LENGTH = 256;
export const EMAIL_VALIDATION_REGEX =
  /^\s*([^@\s]{1,64})@((?:[-a-z0-9]+\.)+[a-z]{2,})\s*$/i;

export function validateEmail(email: string) {
  return (
    email.length <= EMAIL_MAX_LENGTH &&
    validator.matches(email, EMAIL_VALIDATION_REGEX)
  );
}
